import type { ComponentType } from "react";

export type HelpCategoryId =
  | "getting-started"
  | "borrowers"
  | "books"
  | "operations"
  | "admin"
  | "troubleshooting";

export interface HelpCategory {
  id: HelpCategoryId;
  title: string;
  description: string;
  order: number;
}

export interface GuideFrontmatter {
  title: string;
  slug: string;
  category: HelpCategoryId;
  description: string;
  tags: string[];
  order: number;
}

export interface Guide {
  frontmatter: GuideFrontmatter;
  Component: ComponentType<Record<string, unknown>>;
}

export interface FaqEntry {
  id: string;
  category: FaqCategoryId;
  question: string;
  answer: string;
  tags: string[];
  relatedGuides?: string[];
}

export type FaqCategoryId =
  | "buying-trial"
  | "installation"
  | "data-privacy"
  | "hardware"
  | "licences"
  | "day-to-day"
  | "troubleshooting";

export interface FaqCategory {
  id: FaqCategoryId;
  title: string;
  order: number;
}

export const HELP_CATEGORIES: HelpCategory[] = [
  {
    id: "getting-started",
    title: "Getting started",
    description: "Install BookBurrow, activate your licence, and run your first loan.",
    order: 1,
  },
  {
    id: "borrowers",
    title: "Borrowers",
    description: "Import pupils from your MIS, manage records, promote year groups.",
    order: 2,
  },
  {
    id: "books",
    title: "Books & cataloguing",
    description: "Scan barcodes, look up ISBNs, search and filter your catalogue.",
    order: 3,
  },
  {
    id: "operations",
    title: "Day-to-day use",
    description: "Lending, returns, reports, and printing borrower cards.",
    order: 4,
  },
  {
    id: "admin",
    title: "Admin & setup",
    description: "Backups, PIN access, and moving BookBurrow between computers.",
    order: 5,
  },
  {
    id: "troubleshooting",
    title: "Troubleshooting",
    description: "Fix scanner problems and restore data from a backup.",
    order: 6,
  },
];

export const FAQ_CATEGORIES: FaqCategory[] = [
  { id: "buying-trial", title: "Buying & trial", order: 1 },
  { id: "installation", title: "Installation", order: 2 },
  { id: "licences", title: "Licences", order: 3 },
  { id: "day-to-day", title: "Day-to-day use", order: 4 },
  { id: "data-privacy", title: "Data & privacy", order: 5 },
  { id: "hardware", title: "Hardware", order: 6 },
  { id: "troubleshooting", title: "Troubleshooting", order: 7 },
];
